<template>
    <div>
        <b-card no-body>
            <b-card-body>
                <h4 class="heading-1 mb-4">
                    <span>CONTRATOS - Contratos Ativos/Inativos</span>
                </h4>
                <filtros-contratos-ativos-inativos
                    :responsaveis="responsaveis"
                    :unidades="unidades"
                    :fornecedores="fornecedores"
                    :status-opcoes="statusOpcoes"
                    @filtroAtualizado="filtro = $event"
                    @mensagemValidacaoAtualizada="mensagemValidacaoVigencia = $event"
                ></filtros-contratos-ativos-inativos>
            </b-card-body>
            <b-card-footer>
                <app-btn-voltar></app-btn-voltar>
                <b-button
                    variant="primary"
                    @click.stop="emitirRelatorio()"
                    class="ml-2"
                >
                    <span>
                        <i class="fa fa-file-o mr-2"></i> Emitir Relatório</span
                    >
                </b-button>
            </b-card-footer>
        </b-card>
    </div>
</template>

<script>
import FiltrosContratosAtivosInativos from './FiltrosContratosAtivosInativos'
import RelatoriosServicos from './RelatoriosServicos'

export default {
    components: {
        FiltrosContratosAtivosInativos
    },

    data() {
        return {
            responsaveis: null,
            unidades: null,
            fornecedores: null,
            statusOpcoes: null,
            filtro: {
                numeroContrato: null,
                responsavel: null,
                unidade: null,
                fornecedor: null,
                dataInicioVigencia: null,
                dataFimVigencia: null,
                status: null
            },
            mensagemValidacaoVigencia: null
        }
    },

    methods: {
        obterFiltrosOpcoes() {
            this.$store.dispatch('addRequest')
            RelatoriosServicos.obterFiltrosOpcoes('ruft').then((response) => {
                if (response) {
                    if (response.success) {
                        this.responsaveis = response.data.Funcionarios
                        this.responsaveis.unshift({
                            codFuncionario: null,
                            nome: 'TODOS'
                        })
                        this.unidades = response.data.Unidades
                        this.unidades.unshift({
                            codUnidade: null,
                            nome: 'TODAS'
                        })
                        this.fornecedores = response.data.Fornecedores
                        this.fornecedores.unshift({
                            codFornecedor: null,
                            nome: 'TODOS'
                        })
                        this.statusOpcoes = response.data.StatusContratos
                    } else {
                        this.$toast.error(
                            'Erro ao obter opções do filtro!',
                            'ERRO',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        emitirRelatorio() {
            if (this.mensagemValidacaoVigencia) {
                this.$toast.error(
                    this.mensagemValidacaoVigencia,
                    'ERRO',
                    this.$toastConfig.error
                )
                return
            }
            this.$store.dispatch('addRequest')
            RelatoriosServicos.emitirRelatorio(
                'contratosativosinativos',
                this.filtro
            ).then((response) => {
                if (response) {
                    if (response.type === 'application/json') {
                        this.$toast.error(
                            'Erro ao emitir relatório!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    } else {
                        this.$download(response, 'ContratosAtivosInativos.xlsx')
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    mounted() {
        this.obterFiltrosOpcoes()
    }
}
</script>
